var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.45 4.9C12.3202 4.80263 12.1623 4.75 12 4.75C11.8377 4.75 11.6798 4.80263 11.55 4.9L5.05 9.775C4.95685 9.84486 4.88125 9.93545 4.82918 10.0396C4.77711 10.1437 4.75 10.2586 4.75 10.375V18.497C4.75 18.911 5.086 19.247 5.5 19.247H9V16.997C9 16.2014 9.31607 15.4383 9.87868 14.8757C10.4413 14.3131 11.2044 13.997 12 13.997C12.7956 13.997 13.5587 14.3131 14.1213 14.8757C14.6839 15.4383 15 16.2014 15 16.997V19.247H18.5C18.6989 19.247 18.8897 19.168 19.0303 19.0273C19.171 18.8867 19.25 18.6959 19.25 18.497V10.375C19.25 10.2586 19.2229 10.1437 19.1708 10.0396C19.1187 9.93545 19.0431 9.84486 18.95 9.775L12.45 4.9ZM10.65 3.7C11.45 3.1 12.55 3.1 13.35 3.7L19.85 8.575C20.417 9 20.75 9.667 20.75 10.375V18.497C20.75 19.0937 20.5129 19.666 20.091 20.088C19.669 20.5099 19.0967 20.747 18.5 20.747H14.25C14.0511 20.747 13.8603 20.668 13.7197 20.5273C13.579 20.3867 13.5 20.1959 13.5 19.997V16.997C13.5 16.5992 13.342 16.2176 13.0607 15.9363C12.7794 15.655 12.3978 15.497 12 15.497C11.6022 15.497 11.2206 15.655 10.9393 15.9363C10.658 16.2176 10.5 16.5992 10.5 16.997V19.997C10.5 20.1959 10.421 20.3867 10.2803 20.5273C10.1397 20.668 9.94891 20.747 9.75 20.747H5.5C4.90326 20.747 4.33097 20.5099 3.90901 20.088C3.48705 19.666 3.25 19.0937 3.25 18.497V10.375C3.25 9.667 3.583 9 4.15 8.575L10.65 3.7Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/HomeIcon.30175aa6d129fd9694cd6c6e17183b4e.svg";
export { ForwardRef as ReactComponent };